/**
 * Etichette dei modelli LLM.
 * Spec: docs/ai-program/10-byok-and-mcp-rework.md (ADR-107).
 *
 * Qui c'era una mappa hardcoded di modelli con tier ("fast"/"capable") e costo
 * relativo. Aveva senso quando la piattaforma pagava l'inferenza e doveva
 * spingere verso i modelli economici — ed era comunque gia' stantia, elencava
 * `gpt-4o` e `claude-3-5-sonnet`.
 *
 * Ora paga il coach e **la lista arriva dal provider** (`/ai-agent/models`),
 * con le sue etichette. Un modello uscito stamattina e' selezionabile
 * stasera, senza che nessuno aggiorni un file.
 */

/** Etichetta leggibile: quella del provider, o l'id nudo. */
export function getModelLabel(modelId, availableModels = []) {
	if (!modelId) return "Modello";
	const known = availableModels.find((model) => model.id === modelId);
	return known?.label || modelId;
}
